import { EddProgressResponse } from "../types/edd.types";
import useNetworkRequest from "./useNetworkRequest";

interface UseEddProgressParams {
  dependencyCondition?: boolean;
  dependencyList?: any[];
}

const useEddProgress = ({
  dependencyCondition = true,
  dependencyList = []
}: UseEddProgressParams = {}) => {
  return useNetworkRequest<EddProgressResponse>({
    networkCallParams: {
      url: "v2/limits/edd/progress",
      method: "GET",
      service: "wallet"
    },
    dependencyCondition,
    dependencyList
  });
};

export default useEddProgress;
